export default {
    product: `สินค้า`,
    products: `สินค้า`,
    registerProduct: `ลงทะเบียนสินค้า`,
    mainInformation: 'ข้อมูลหลัก',
    searchCustomerDetailsAndLocations: 'ค้นหารายละเอียดและสถานที่ของลูกค้า',
    searchCustomerByMarking: 'ค้นหาลูกค้าจากสัญลักษณ์',
    entry: 'บันทึกข้อมูล',
    barcode: 'บาร์โค้ด',
    modifyItemsForEntry: 'แก้ไขข้อมูลรายการ',
    updateProduct: 'อัปเดตสินค้า',
    item: 'รายการ',
    addProductItem: 'เพิ่มรายการ',
    updateProductItem: 'อัปเดตรายการ',

    information: 'ข้อมูล',
    detailInformationDescribedTheProducts: 'ข้อมูลรายละเอียดที่อธิบายสินค้า',
    containerInfo: 'ข้อมูลภาชนะ',
    detailInformationAssignedToContainer: 'ข้อมูลรายละเอียดที่กำหนดให้ภาชนะ',
    detailInformationDescribedTheItems: 'ข้อมูลรายละเอียดที่อธิบายรายการ',
    updateProductInformation: 'อัปเดตข้อมูลสินค้า',
    updateItemInformation: 'อัปเดตข้อมูลรายการ',
    updateProductImages: 'อัปเดตรูปภาพสินค้า',
    removeItem: 'ลบรายการ',
    areYouSureToDeleteThisItem: 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?',
    yesIveConfirmed: 'ใช่ ฉันยืนยันแล้ว',
    savedImages: 'รูปภาพที่บันทึกไว้',
    describedTheImageInformation: 'อธิบายข้อมูลของรูปภาพ',
    noImagesSaved: 'ไม่มีรูปภาพที่บันทึกไว้',
    dropImagesHereOrClickToSelectFilesForUpload: 'ลากรูปภาพมาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์เพื่ออัปโหลด',
    clearAll: 'ล้างทั้งหมด',
    confirmUpload: 'ยืนยันการอัปโหลด',
    galleryImage: 'รูปภาพในคลัง',

    mainlandIdentityCard: 'บัตรประชาชนจีนแผ่นดินใหญ่',
    currentImage: 'รูปภาพปัจจุบัน',
    previewImage: 'แสดงตัวอย่างรูปภาพ',

    itemCode: 'รหัสรายการ',
    scanningSuffix: 'ส่วนต่อท้ายสำหรับการสแกน',
    prepayDepositFee: 'ค่ามัดจำล่วงหน้า',
    prepayTransportFee: 'ค่าขนส่งล่วงหน้า',
    companyPurchaseNo: 'หมายเลขการสั่งซื้อของบริษัท',
    handleUnit: 'หน่วยการจัดการ',
    dimension: 'ขนาด (LxHxW)',
    total: 'ทั้งหมด',

    assignedDO: 'ใบสั่งส่งสินค้าที่กำหนดไว้',
    signedByUser: `ลงนามโดยผู้ใช้งาน`,
    lastSaved: `บันทึกล่าสุด`,
    searchBarcode: 'ค้นหารหัสบาร์โค้ด',

    unsaved: `ยังไม่ได้บันทึก`,
    reset: `รีเซ็ต`,
    checkedInAt: `เช็คอินที่เวลา`,
    hideMarking: 'ซ่อนสัญลักษณ์',
    openMarking: 'เปิดสัญลักษณ์',

    changeOwner: `เปลี่ยนเจ้าของ`,
    latestResultFor: `ผลลัพธ์ล่าสุดสำหรับ`,
    searchMarking: `ค้นหาสัญลักษณ์บรรจุภัณฑ์`,
    searchRelatedProductsByTheMarking: `ค้นหาสินค้าที่เกี่ยวข้องตามสัญลักษณ์`,
    applyTo: `ใช้กับ`,
    confirmChangeOwnerToThisMarking: `ยืนยันการเปลี่ยนเจ้าของไปยังสัญลักษณ์นี้`,
    markingCannotEmpty: `สัญลักษณ์ไม่สามารถเว้นว่างได้`,
    markingCannotBeSame: `สัญลักษณ์ไม่สามารถซ้ำกันได้`,
    invalidMarkingInUpstream: `สัญลักษณ์ไม่ถูกต้องในระบบต้นทาง`,
    markingIsTrashInUpstream: `สัญลักษณ์นี้ถูกย้ายไปยังถังขยะในระบบต้นทาง`,
    markingIsDeletedInUpstream: `สัญลักษณ์นี้ถูกลบในระบบต้นทาง`,
    markingIsDisabledInUpstream: `สัญลักษณ์นี้ถูกปิดใช้งานในระบบต้นทาง`,
    invalidMarking: `สัญลักษณ์ไม่ถูกต้อง`,
    moreThanOneMarkingExists: `มีสัญลักษณ์มากกว่าหนึ่งรายการ`,
    upSteamSourceMarkingRemIdNotMatched: `รหัสสัญลักษณ์ในระบบต้นทางไม่ตรงกัน`,

    failedToDeleteTheFirstRowOfSavedItems: "ไม่สามารถลบแถวแรกของรายการที่บันทึกไว้ได้",
    deleteFirstRowOfSavedItems: "ลบแถวแรกของรายการที่บันทึกไว้",

    printPackQty: 'จำนวนบรรจุที่พิมพ์',
    appEntry: 'รายการแอป',
    byApp: 'ใช่',
    notFromApp: 'ไม่มี',
    insertRows: 'แทรกแถว',
    calculate: 'คำนวณ',
    tableGridV1: "ตารางกริดเก่า",
    tableGridV2: "ตารางกริดใหม่",

    maxOnly: 'สูงสุดเท่านั้น',
    successfullyAdded: 'เพิ่มเรียบร้อยแล้ว',
    deleted: 'ลบเรียบร้อยแล้ว',
    success: 'สำเร็จ',
    failed: 'ล้มเหลว',
    minAtLeast1Item: 'ขั้นต่ำอย่างน้อย 1 รายการ',
    someOfItemsHasNotSyncFinished: 'บางรายการยังซิงค์ไม่เสร็จ [sourceRemId ว่างอยู่]',
    minSelectOneItem: 'เลือกอย่างน้อย (1) รายการ',
    failedToUpdate: 'อัปเดตล้มเหลว',

    printLabels: "พิมพ์ฉลาก",
    cancel: 'ยกเลิก',
    printNo: 'จำนวนครั้งที่พิมพ์',

    unit: 'UNIT',
    box: 'BOX',
    sack: 'SACK',
    pallet: 'PALLET',
    wooden: 'WOODEN',
    long: 'LONG',

    filterAll: "กรองทั้งหมด",
    filterSimilar: "กรองคล้ายกัน",

    // ------MUI------
    productName: 'ชื่อสินค้า',
    signedBy: 'ลงนามโดย',
    addItems: 'เพิ่มรายการ',

    gender: 'เพศ',
    nation: 'สัญชาติ',
    dateOfBirth: 'วันเกิด',
    identityNo: 'หมายเลขประจำตัวประชาชน',
    department: 'แผนก',
    validityTime: 'วันที่เริ่มใช้บังคับ',

    payFreight: 'ชำระค่าขนส่ง',
    payDeposit: 'ชำระเงินมัดจำ'
}